import { useState } from "react";
import { useUpdateSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";
import { useNavigate, useParams } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { cleanObject } from "../../../../helpers";

const days = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const useSmsCampaignScheduleForm = ({ smsCampaign = {} }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: smsCampaign?.title || "",
    frequency: smsCampaign?.schedule_settings?.frequency || "ONE_TIME",
    time:
      smsCampaign?.schedule_settings?.time
        ?.split(":")
        ?.slice(0, 2)
        ?.join(":") || "",
    start_date: smsCampaign?.schedule_settings?.start_date || "",
    end_date: smsCampaign?.schedule_settings?.end_date || "",
    days: smsCampaign?.schedule_settings?.days?.filter((item) => item) || [],
    delivery_type: smsCampaign?.delivery_type || "IMMEDIATE",
  });

  console.log(formData);

  const { mutate: updateSmsCampaign, isLoading: isSubmiting } =
    useUpdateSmsCampaigns(id);
  const handleSubmitSchedule = () => {
    updateSmsCampaign(
      {
        data: cleanObject(
          {
            delivery_type: formData?.delivery_type,
            title: formData?.title,
            schedule_settings: cleanObject({ ...formData }, [
              "title",
              "delivery_type",
            ]),
          },
          [formData?.delivery_type === "IMMEDIATE" ? "schedule_settings" : ""],
        ),
        id,
      },
      {
        onSuccess: () => {
          navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_REVIEW({ id }));
        },
      },
    );
  };

  return { isSubmiting, formData, days, setFormData, handleSubmitSchedule };
};
